import React from "react";
import { UserAuth } from "../context/AuthContext";

const Forbidden = () => {
  const { user } = UserAuth();

  return (
    <>
      <div className="w-full h-full pt-24 align-middle">
      <h1 className="text-center font-bold py-24 text-white">
        Forbidden: Access Denied
      </h1>

      {user?.uid && (
        <h2 className="text-center font-bold py-24 text-white">
          Your UID is: {user.uid}
        </h2>
      )}
      </div>
    </>
  );
};

export default Forbidden;
